<script>
/**
 * Imperative watermark setter — sets `data-watermark` and `data-watermark-state`
 * on the closest `.print-page` ancestor. Use when the watermark needs to differ
 * per page (e.g. the second copy is "DUPLICATE", the first is "ORIGINAL").
 *
 * The CSS in `_watermarks.scss` reads these attributes; this component only
 * injects them. The rendered span is `display: none` so it has no layout
 * impact but exists so `$el.parentElement` reliably resolves.
 *
 * For the simple case (one watermark for the whole document), pass the
 * `watermark` prop to `<PrintLayout>` instead — saves a node.
 */
export default {
  name: "PrintWatermark",
  props: {
    text: { type: String, required: true },
    state: {
      type: String,
      default: "draft",
      validator: (v) => ["draft", "cancelled", "duplicate"].includes(v),
    },
  },
  mounted() { this.applyAttrs(); },
  updated() { this.applyAttrs(); },
  methods: {
    applyAttrs() {
      let el = this.$el?.parentElement;
      while (el && !el.classList.contains("print-page")) {
        el = el.parentElement;
      }
      if (!el) return;
      el.setAttribute("data-watermark", this.text);
      el.setAttribute("data-watermark-state", this.state);
    },
  },
};
</script>

<template>
  <span aria-hidden="true" class="print-watermark-anchor" />
</template>

<style scoped>
.print-watermark-anchor { display: none; }
</style>
